import api from '.';

class Auth {
  static async getUser() {
    const user = await api.get('/auth/me');
    return user?.data;
  }

  static async login(data) {
    const result = await api.post('/auth/login', data);
    return result.data;
  }

  static async submitEmailForPasswordReset(data) {
    const result = await api.post('/auth/reset-password', data);
    return result.data;
  }

  static async resetPassword(data) {
    const result = await api.post(`/auth/reset-password/${data.resetCode}`, {
      email: data.email,
      password: data.password,
    });
    return result.data;
  }

  static async getUserWithCode(code: string) {
    const user = await api.get(`/auth/login/${code}`);
    return user?.data;
  }

  static async getSignInUrl(data) {
    const result = await api.post('/auth/sign-in-url', data);
    return result.data;
  }
}

export default Auth;
